// extracted by mini-css-extract-plugin
export var container = "SessionDetail-module--container--2LTM-";
export var closeBtn = "SessionDetail-module--closeBtn--y1I2n";
export var header = "SessionDetail-module--header--1TRAP";
export var content = "SessionDetail-module--content--3M2vX";
export var tagList = "SessionDetail-module--tagList--2kF7D";
export var speaker = "SessionDetail-module--speaker--2YoQX";
export var button = "SessionDetail-module--button--29bjP";